<div class="app-container" appButtonController>
  <router-outlet></router-outlet>
  <app-loader></app-loader>
</div>
